import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import logo from '../../../img/logo/icon_cosmocare.svg';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0,
  },
  appBar: {
    background: '#F8F8F8',
    color: '#222',
    zIndex: theme.zIndex.drawer + 1,
  },
  iconButton: {
    width: 36,
    height: 36,
    color: '#fff',
    fontWeight: 100
  },
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }
});

class AppBarRegister extends React.PureComponent {
  
  handleBackButton = (e) => {
    this.props.history.goBack()
  }

  render() {
    const { classes } = this.props;

    return (
      <AppBar position="static"  style={{ background: 'transparent', boxShadow: 'none'}}>
        <Toolbar>
            {/*
            <IconButton className={classes.menuButton} onClick={this.props.backAction ? this.props.backAction : this.handleBackButton} style={{color: '#ddd'}}>
              <ArrowBack />
            </IconButton>*/}
            {!this.props.hideLogo &&
            <Typography variant="title" color="inherit" className={classes.flex}>
              <img src={logo} style={{maxHeight: 28, marginLeft: -30}} />
            </Typography>
            }
            {this.props.title &&
            <Typography variant="headline" className={classes.flex} style={{color: 'black', marginLeft: 0}}>
              {this.props.title}
            </Typography>
            }
        </Toolbar>
      </AppBar>
    )
  }
}

export default withRouter(withStyles(styles)(AppBarRegister));


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppBarRegister.js